import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import ru from "./locales/ru.json"
import uzCyrl from "./locales/uzCyrl.json"
import uzLatn from "./locales/uzLatn.json"

// the translations
const resources = {
	"ru": {
    translation: ru,
  },
	"uz-Cyrl-UZ": {
    translation: uzCyrl,
  },
	"uz-Latn-UZ": {
    translation: uzLatn,
  },
}

const language = localStorage.getItem("I18N_LANGUAGE")
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "ru")
}

// Backend uses AngularCookieLocaleResolver on NG_TRANSLATE_LANG_KEY; the %22
// wrapping is AngularJS's ngCookies format and is what the resolver strips off.
document.cookie = `NG_TRANSLATE_LANG_KEY=%22${localStorage.getItem("I18N_LANGUAGE")}%22; path=/; max-age=31536000`

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "ru",
    fallbackLng: "ru", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
